import { acpAgentCatalogEntryForAlias } from '@crowdex/agent-contracts';
import { resolvePersistedAgent } from '@/lib/desktop-shell/cloud-agents';
import type { NativeAgent } from '@/lib/native-desktop';

function preferredCommand(model: string): string | null {
  if (model === 'auto') return null;
  return acpAgentCatalogEntryForAlias(model)?.id ?? model;
}

export function selectElectronAgentId(
  agents: readonly NativeAgent[],
  current: string,
  model: string,
): string {
  const persisted = resolvePersistedAgent(agents, current);
  if (persisted !== undefined) return persisted.id;
  const command = preferredCommand(model);
  if (command !== null) {
    const localId = acpAgentCatalogEntryForAlias(model)?.localId ?? null;
    const preferred =
      agents.find((candidate) => candidate.id === localId) ??
      agents.find(
        (candidate) => candidate.command === command || candidate.command.endsWith(`/${command}`),
      );
    if (preferred !== undefined) return preferred.id;
  }
  const defaultId = acpAgentCatalogEntryForAlias('claude')?.localId;
  return agents.find((candidate) => candidate.id === defaultId)?.id ?? agents[0]?.id ?? '';
}
